/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React, {MutableRefObject, useCallback} from 'react';
import {Skeleton} from '@ion/dls/src/components/skeleton/Skeleton';

// defines the SisenseSkeleton props definitions...
export interface SisenseSkeletonProps {
  parentRef: MutableRefObject<any>;
};

// defaults offset
const offset = 400;

/**
 * The shared component is used for indicates the loading status to the user
 * with skeleton loader. This is required for all siense iframe loading to
 * calculate the parent frame or div widhth and height.
 *
 * ```typescript
 *
 *  const SomeComponent = () => {
 *    const rootRef = useRef();
 *    return (
 *      <div ref={rootRef}>
 *        <SisenseSkeleton parentRef={rootRef} />
 *      </div>
 *    );
 *  }
 *
 * ```
 */
export const SisenseSkeleton = ({parentRef}: SisenseSkeletonProps) => {
  const getSkeletonHeight = useCallback((): number => (
    parentRef.current?.offsetHeight - 36 ?? offset
  ), [parentRef]);

  const getSkeletonWidth = useCallback((): number => (
    parentRef.current?.offsetWidth - 12 ?? offset
  ), [parentRef]);

  return (
    <Skeleton variant='rect' animation='wave' width={getSkeletonWidth()} height={getSkeletonHeight()} />
  );
};

export default SisenseSkeleton;
